<template>
  <card-component title="Profil Bilgileri Güncelleme" icon="account-circle">
    <form @submit.prevent="submit">
      <b-field horizontal>
        <b-field>
          <b-input
            v-model="form.name"
            icon="account"
            :placeholder="$t('fullName')"
          />
        </b-field>
        <b-field>
          <b-input
            v-model="form.username"
            icon="account"
            :placeholder="$t('username')"
            validation-message="Kullanıcı adı zorunlu."
            required
          />
        </b-field>
      </b-field>
      <b-field horizontal>
        <b-input
          v-model="form.email"
          type="email"
          icon="email"
          :placeholder="$t('email')"
        />
      </b-field>
      <b-field horizontal>
        <b-field>
          <VuePhoneNumberInput
            ref="phone"
            v-model="form.phone"
            :default-country-code="phoneCountryCode"
            required
            @update="updatePhone"
          />
        </b-field>
      </b-field>
      <hr>
      <b-field horizontal>
        <div class="control">
          <button type="submit" class="button is-primary" :class="{'is-loading':isLoading}">
            Güncelle
          </button>
        </div>
      </b-field>
    </form>
  </card-component>
</template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js'

export default {
  name: 'ProfileUpdateForm',
  components: {
    CardComponent,
    VuePhoneNumberInput: () => import('vue-phone-number-input'),
  },
  data () {
    return {
      isFileUploaded: false,
      isLoading: false,
      phoneCountryCode: 'TR',
      form: {
        name: null,
        username: null,
        email: null,
        phone: null,
      },
    }
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  watch: {
    user (newValue) {
      this.form.name = newValue.attributes.name
      this.form.username = newValue.attributes.username
      this.form.email = newValue.attributes.email
      this.form.phone = this.formatPhoneNumberNational(newValue.attributes.phone)
    }
  },
  mounted () {
    this.form.name = this.user.attributes?.name
    this.form.username = this.user.attributes?.username
    this.form.email = this.user.attributes?.email
    this.form.phone = this.formatPhoneNumberNational(this.user.attributes?.phone)
  },
  methods: {
    formatPhoneNumberNational (number) {
      if (!number) {
        return null
      }

      const asYouType = new AsYouType()
      asYouType.input(number)

      if (!asYouType.getNumber()) {
        return null
      }

      const phone = parsePhoneNumberFromString(asYouType.getNumber().number, asYouType.getNumber().country)
      return phone.formatNational()
    },
    formatPhoneNumberInternational (number) {
      if (!number) {
        return null
      }

      const asYouType = new AsYouType(this.phoneCountryCode)
      asYouType.input(number)

      return asYouType.getNumber().number ?? null
    },
    updatePhone (data) {
      this.phoneCountryCode = data.countryCode
      this.form.phone = data.e164
    },
    submit () {
      const data = {
        ...this.form,
        ...{ phone: this.formatPhoneNumberInternational(this.form.phone) }
      }

      if (!this.validate(data)) {
        return this.$buefy.toast.open({
          message: 'Lütfen bilgilerinizi doğru giriniz.',
          type: 'is-danger',
          queue: false,
        })
      }

      this.isLoading = true

      this.$http.put('profile', data).then(({ data }) => {
        if (data.success) {
          this.$buefy.toast.open({
            message: 'Profiliniz başarıyla güncellendi.',
            type: 'is-success',
            queue: false,
          })
        }
      }).catch(({ response }) => {
        const errors = this.$_.flattenDeep(this.$_.values(response.data.error.errors)).join('<br>')
        this.$buefy.toast.open({
          message: errors,
          type: 'is-danger',
          duration: 5000,
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    validate (data) {
      if (!data.username || this.formatPhoneNumberInternational(data.phone).length !== 13) {
        return false
      }

      return true
    }
  }
}
</script>
